<template>
  <div
    class="t-widget t-count-widget"
    :class="[
      { 't-count-widget--reversed': reversed },
      { 't-count-widget--card': card },
    ]"
  >
    <div class="t-count-widget__body">
      <small class="t-count-widget__label">{{ label }}</small>
      <span class="t-count-widget__featured"><slot></slot></span>
    </div>
    <div class="t-count-widget__icon">
      <t-icon :icon="icon" :type="type" boxed></t-icon>
    </div>
  </div>
</template>

<script>
import ColorTypeMixin from '../../mixins/ColorTypeMixin';
import { TIcon } from '../TIcon';

export default {
  name: 't-count-widget',

  mixins: [ColorTypeMixin],

  props: {
    label: {
      type: String,
      required: true,
    },
    icon: [Array, String],
    reversed: Boolean,
    card: Boolean,
  },

  components: {
    TIcon,
  },
};
</script>
